import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { AdminV3JudgePage } from '@apps/web/features/admin_v3_judge';
import { judgeSearchSchema } from '@apps/web/features/admin_v3_judge/search_params';

export const Route = createFileRoute('/_app/admin/agent/judge/')({
    head: () => ({
        meta: [{ title: 'Judge | Internal Admin Agent' }],
    }),
    validateSearch: judgeSearchSchema,
    component: AdminV3JudgeRoute,
});

function AdminV3JudgeRoute() {
    const search = Route.useSearch();
    const navigate = useNavigate({ from: Route.fullPath });
    return (
        <AdminV3JudgePage
            search={search}
            onSearchChange={(next, replace) =>
                void navigate({ search: next, replace, resetScroll: false })
            }
        />
    );
}
